<!-- Affichage du cadre de récapitulatif des frais -->
<od-engagements-card
        [title]="'od.engagements.frais.title' | translate"
        [engagements]="engagements"
        [avatar]="avatar"></od-engagements-card>

<!-- Template de l'avatar -->
<ng-template #avatar let-engagement="engagement" let-isPrevisionnel="isPrevisionnel" let-isTotal="isTotal">
    <div class="avatar" [nioTooltip]="isTotal ? (engagement?.getTraduction(isPrevisionnel) | translate) : engagement?.libellePrestation" nioTooltipPosition="right">
        <!--
            Petit hack ici pour que les images fonctionnent en dév avec le proxy ET en prod.
            Le pb étant que statutImage est stocké en bdd et qu'il contient un chemin relatif vers l'image, qui ne fonctionne pas pour Angular car Angular est déployé à la racine de la webapp,
            contrairement à AngularJS et XSL.
        -->
        <mat-icon *ngIf="!isTotal && engagement?.iconePrestation" class="material-icons">{{ engagement.iconePrestation }}</mat-icon>
        <span *ngIf="isTotal" class="align-middle" [translate]="'od.engagements.' + (isPrevisionnel ? 'previsionnelAvatar' : 'reelAvatar')"></span>
    </div>
</ng-template>